// @flow
import * as types from './mutation-types'
import type { InvoiceSpecificationsState } from './index'
import type { InvoiceSummary } from '../../../types/invoice-summary'

export default {
  [types.SET_INVOICE_SPECIFICATIONS_FOR_CURRENT_FILTER]: (state: InvoiceSpecificationsState, invoices: InvoiceSummary[]): void => {
    state.invoiceSpecificationsForCurrentFilter = invoices
  },
  [types.SET_TOTAL_NO_INVOICE_SPECIFICATIONS_FOR_CURRENT_FILTER]: (state: InvoiceSpecificationsState, count: number): void => {
    state.totalNoInvoiceSpecificationsForCurrentFilter = count
  },
  [types.SET_INVOICE_SPECIFICATIONS_CURRENT_PAGE_NUMBER]: (state: InvoiceSpecificationsState, { number }: { number: number }): void => {
    state.invoiceSpecificationsCurrentPageNumber = number
  },
  [types.SET_INVOICE_SPECIFICATIONS_PAGE_SIZE]: (state: InvoiceSpecificationsState, number: number): void => {
    state.invoiceSpecificationsPageSize = number
    let noPages = Math.ceil(state.totalNoInvoiceSpecificationsForCurrentFilter / number)
    if (state.invoiceSpecificationsCurrentPageNumber >= noPages) {
      state.invoiceSpecificationsCurrentPageNumber = noPages - 1
    }
  },
  [types.SET_INVOICE_SPECIFICATIONS_ORDER_BY]: (state: InvoiceSpecificationsState, invoiceSpecificationsOrderBy: ?string): void => {
    state.invoiceSpecificationsOrderBy = invoiceSpecificationsOrderBy
  },
  [types.SET_INVOICE_SPECIFICATIONS_ORDER_DIRECTION]: (state: InvoiceSpecificationsState, invoiceSpecificationsOrderDirection: ?string): void => {
    state.invoiceSpecificationsOrderDirection = invoiceSpecificationsOrderDirection
  },
  [types.SET_INVOICE_SPECIFICATIONS_FILTER_INVOICE_NUMBER]: (state: InvoiceSpecificationsState, value: string): void => {
    state.invoiceSpecificationsFilterInvoiceNumber = value
  },
  [types.SET_INVOICE_SPECIFICATIONS_FILTER_INVOICE_DATE]: (state: InvoiceSpecificationsState, value: string): void => {
    state.invoiceSpecificationsFilterInvoiceDate = value
  },
  [types.SET_INVOICE_SPECIFICATIONS_FILTER_INVOICE_MONTH]: (state: InvoiceSpecificationsState, value: string): void => {
    state.invoiceSpecificationsFilterInvoiceMonth = value
  },
  [types.SET_INVOICE_SPECIFICATIONS_FILTER_INVOICE_YEAR]: (state: InvoiceSpecificationsState, value: string): void => {
    state.invoiceSpecificationsFilterInvoiceYear = value
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/invoice-specifications/mutations.js